export const heroContent = {
  title: "Itaobuy Spreadsheet Italia: Trova i migliori prodotti cinesi in modo semplice e intelligente",
  subtitle: "Il punto di riferimento italiano per scoprire Itaobuy Spreadsheet aggiornati, categorie prodotto, guide dettagliate e consigli per acquistare online con maggiore sicurezza.",
  primaryCta: "Scopri Itaobuy Spreadsheet",
  secondaryCta: "Itaobuy Sheet",
  buyNowCta: "Buy It Now",
  trustBadges: [
    "Aggiornamenti frequenti",
    "Guide in italiano",
    "Analisi prodotti",
    "Consigli sicurezza"
  ]
};

export const aboutContent = {
  title: "Cos'è Itaobuy Spreadsheet?",
  paragraphs: [
    "Itaobuy Spreadsheet è una raccolta organizzata di prodotti selezionati che permette agli utenti di trovare articoli interessanti senza perdere ore nella ricerca manuale. Nato dall'esigenza di semplificare l'accesso ai migliori prodotti disponibili sui marketplace internazionali, questo strumento è diventato il punto di riferimento per chi cerca qualità e convenienza.",
    "Grazie agli spreadsheet aggiornati puoi esplorare categorie come sneakers, moda, accessori e prodotti tech in modo più veloce. Ogni foglio è curato manualmente da esperti del settore che verificano personalmente la qualità dei prodotti e l'affidabilità dei fornitori, garantendoti un'esperienza di shopping sicura e senza sorprese."
  ]
};

export const benefitsContent = {
  title: "Perché utilizzare Itaobuy Spreadsheet?",
  subtitle: "Vantaggi",
  benefits: [
    {
      id: 1,
      icon: "ri-time-line",
      title: "Risparmio di tempo",
      description: "Trova prodotti organizzati senza effettuare infinite ricerche manuali. I nostri spreadsheet ti permettono di accedere a centinaia di prodotti verificati in pochi secondi."
    },
    {
      id: 2,
      icon: "ri-star-line",
      title: "Migliore selezione",
      description: "Accedi a liste curate e categorie specifiche. Ogni prodotto è stato selezionato in base a criteri rigorosi di qualità, prezzo e affidabilità del venditore."
    },
    {
      id: 3,
      icon: "ri-shield-check-line",
      title: "Maggiore controllo",
      description: "Consulta informazioni, immagini e dettagli prima dell'acquisto. Prendi decisioni informate con tutti i dati necessari a portata di mano."
    },
    {
      id: 4,
      icon: "ri-user-heart-line",
      title: "Esperienza semplice",
      description: "Anche i principianti possono iniziare facilmente. L'interfaccia intuitiva e le guide passo-passo rendono l'esperienza accessibile a tutti."
    }
  ]
};

export const comparisonContent = {
  title: "Itaobuy Spreadsheet vs Ricerca Tradizionale",
  rows: [
    { feature: "Prodotti organizzati", spreadsheet: true, traditional: false },
    { feature: "Risparmio tempo", spreadsheet: "Alto", traditional: "Basso" },
    { feature: "Categorie disponibili", spreadsheet: "Molte", traditional: "Limitate" },
    { feature: "Facile per principianti", spreadsheet: true, traditional: false },
    { feature: "Guide disponibili", spreadsheet: true, traditional: false },
    { feature: "Aggiornamenti regolari", spreadsheet: "Settimanali", traditional: "Manuali" }
  ]
};

export const safetyContent = {
  title: "Itaobuy Spreadsheet è sicuro?",
  paragraphs: [
    "La sicurezza è una nostra priorità assoluta. Prima di utilizzare qualsiasi risorsa online è importante verificare sempre informazioni, qualità dei prodotti e affidabilità dei venditori. Con Itaobuy Spreadsheet hai accesso a prodotti verificati e recensiti dalla nostra community di utenti esperti."
  ],
  checklist: [
    "Controllare immagini prodotto reali",
    "Valutare recensioni verificate",
    "Verificare dettagli spedizione",
    "Utilizzare metodi pagamento affidabili",
    "Consultare le guide disponibili",
    "Partecipare alla community"
  ]
};

export const ctaContent = {
  title: "Pronto a scoprire il miglior Itaobuy Spreadsheet?",
  subtitle: "Accedi alle liste aggiornate e inizia a risparmiare oggi",
  button: "Accedi alla risorsa completa"
};

export const articleTeaserContent = {
  label: "GUIDA SEO 2026",
  titleFirst: "La Guida Definitiva",
  titleSecond: "su Itaobuy",
  titleThird: "Spreadsheet",
  description: "Scopri tutto ciò che devi sapere su Itaobuy Spreadsheet: come funziona, quali sono i vantaggi, come scegliere i prodotti migliori e molto altro ancora. Una guida completa scritta in italiano per aiutarti a navigare il mondo dello shopping internazionale con sicurezza e facilità.",
  button: "Leggi l'articolo completo"
};